(function disableInputsAutocompleteDefinition() {

    'use strict';

    angular.module('DisableInputsAutocomplete', [])
        .directive('input', function() {
            return {
                restrict: 'E',                
                link: function(scope, element, attrs) {
                    if (!element.attr('autocomplete')) {
                        element.attr('autocomplete', 'false');   // Seteo en false y no off porque sino en chrome no anda
                    }
                }
            };
        });
})();
